import React from 'react';
import PropTypes from 'prop-types';
import AppLoader from 'main/core/AppLoader';

const appSuspenseDefault = {
  loadingProps: {
    delay: 300,
  },
};
const AppSuspense = (props = {appSuspenseDefault}) => {
  return (
    <>
      <React.Suspense fallback={<AppLoader />}>{props.children}</React.Suspense>
    </>
  );
};

AppSuspense.propTypes = {
  loadingProps: PropTypes.object,
};

export default AppSuspense;

AppSuspense.propTypes = {
  children: PropTypes.node.isRequired,
};
